import { User } from '../users/user.model';

export class HistoryGroup {
  id: number;
  name: string;
  users: User[] = [];

  public constructor(init?:Partial<HistoryGroup>) {
    Object.assign(this, init);
  }
}


// WEBPACK FOOTER //
// ./src/app/history/history-group.model.ts